import React from "react";
import useSWR from "swr";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import OpenStudioCard from "./OpenStudioCard";

const API_URL = `${process.env.REACT_APP_API_FOLDER}list_openstudios/`;
const API_TOKEN = process.env.REACT_APP_API_TOKEN;

const fetcher = (url) =>
  fetch(url, { headers: { "X-API-TOKEN": API_TOKEN } }).then((response) => {
    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.status}`);
    }
    return response.json();
  });

function OpenStudiosWrap() {
  const { data, error, isLoading } = useSWR(API_URL, fetcher);
  const studios = Array.isArray(data) ? data : [];
  const apiError = data && !Array.isArray(data) && data.error ? data.error : null;

  if (isLoading) {
    return (
      <section className="openstudios-page section-bottom-pad">
        <div className="package-sidebar-wrapper pt-110">
          <div className="container">
            <div className="row g-4">
              {Array(6)
                .fill(null)
                .map((_, index) => (
                  <div className="col-lg-4 col-md-6" key={index}>
                    <Skeleton height={350} />
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="openstudios-page section-bottom-pad">
      <div className="package-sidebar-wrapper pt-110">
        <div className="container">
          <header className="openstudios-catalogue-intro">
            <h1>Open Studios</h1>
            <p>
              Free online sessions with artists from the CAMP community:
              demonstrations, talks, listening sessions, studio tours and
              practical explorations of creative work.
            </p>
          </header>

          {(error || apiError) && (
            <div className="alert alert-danger" role="alert">
              {apiError || "Open Studios could not be loaded."}
            </div>
          )}

          {!error && !apiError && studios.length > 0 && (
            <div className="row g-4">
              {studios.map((studio) => (
                <div className="col-lg-4 col-md-6 fadeffect" key={studio.id}>
                  <OpenStudioCard studio={studio} />
                </div>
              ))}
            </div>
          )}

          {!error && !apiError && studios.length === 0 && (
            <div className="openstudios-empty">
              <h2>No upcoming Open Studios right now</h2>
              <p>New sessions will appear here as soon as they are announced.</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default OpenStudiosWrap;
